import React from 'react';
import './Amenagementstitre.css';

const Amenagementstitre= () => {
    return (
        <div className='meres1'>

        <div className='container111'>
            

                <h2>Aménagements</h2>
     
            </div>
            
           <div className='texte3an'>
            <p>
                Bienvenue dans la rubrique aménagements de la Mairie du 2e Arrondissement de Port-Gentil. Ici vous trouverez toutes les informations sur les projets de develeppement urbain et d'infrastructure de notre Arrondissement. L'Aménagement de notre territoire vise à améliorer la qualité de vie de nos citoyens tout en respectant l'Environnement. Que ce soit la création de nouveaux espaces publics, la réhabilitation des infrastructures existantes, ou l'intégration de solutions durables, nous nous engageons à transformer notre cadre de vie pour le bien-etre de tous. Découvrez les projets en cours, les plans futurs, et comment ils contribuent à la modernisation de notre Arrondissement.
            </p>
           </div>
    </div>
    
    );
};

export default Amenagementstitre;
